
<a #button id="airplay" href="javascript:;" (click)="click()" title="AirPlay">

	<ng-container *ngIf="isAudio">
		<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
		<svg version="1.1" id="text-OL" x="0px" y="0px"
				viewBox="0 0 125 125" style="enable-background:new 0 0 125 125;" xml:space="preserve">
		<rect class="st0" width="125" height="125"/>
		<g id="_Group_">
			<g id="_Group_2">
				<path id="_Path_" class="st1" d="M43.5,84.1l1.3-1.5c0.3-0.3,0.3-0.8,0-1.1c-10.5-9.7-11.2-26.2-1.4-36.7s26.2-11.2,36.7-1.4
					s11.2,26.2,1.4,36.7c-0.5,0.5-0.9,1-1.4,1.4c-0.3,0.3-0.3,0.8,0,1.1l1.3,1.5c0.3,0.3,0.8,0.3,1.1,0.1c0,0,0,0,0,0
					c12-11.1,12.7-29.7,1.7-41.7c-11.1-12-29.7-12.7-41.7-1.7s-12.7,29.7-1.7,41.7c0.5,0.6,1.1,1.1,1.7,1.7
					C42.8,84.4,43.2,84.4,43.5,84.1z"/>
				<path id="_Path_2" class="st1" d="M44.8,62.5c0-9.7,7.9-17.6,17.6-17.6S80,52.9,80,62.6c0,4.8-2,9.5-5.5,12.8
					c-0.3,0.3-0.3,0.8,0,1.1l1.3,1.5c0.3,0.3,0.8,0.4,1.1,0.1c0,0,0,0,0,0c8.5-8,8.9-21.3,1-29.8s-21.3-8.9-29.8-1S39.1,68.5,47,77
					c0.3,0.3,0.6,0.7,1,1c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l1.3-1.5c0.3-0.3,0.3-0.8,0-1.1C46.9,72.1,44.8,67.4,44.8,62.5z"/>
				<path id="_Path_3" class="st1" d="M53.2,62.5c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2c0,2.5-1,4.8-2.8,6.6
					c-0.3,0.3-0.3,0.8,0,1.1l1.3,1.5c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0c5-4.9,5.2-12.9,0.3-18s-12.9-5.2-18-0.3s-5.2,12.9-0.3,18
					c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l1.3-1.5c0.3-0.3,0.3-0.8,0-1.1C54.2,67.4,53.2,65,53.2,62.5z"/>
			</g>
			<path id="_Path_4" class="st1" d="M80.9,89.1L63.5,69.3c-0.5-0.6-1.3-0.6-1.9-0.1c0,0-0.1,0.1-0.1,0.1L43.9,89.1
				c-0.4,0.5-0.4,1.2,0.1,1.7c0.2,0.2,0.5,0.3,0.7,0.3h35.3c0.6,0,1.2-0.5,1.2-1.2C81.2,89.6,81.1,89.3,80.9,89.1z"/>
		</g>
		</svg>
			
	</ng-container>
	<ng-container *ngIf="!isAudio">

		<ng-container *ngIf="connected">
			<svg height="100%" version="1.1" viewBox="0 0 36 36" style="transform: scale(0.9)">
				<use class="ytp-svg-shadow" NS1:href="#ytp-id-33"></use>
				<path d="M11,13 L25,13 L25,21 L11,21 L11,13 Z M12,28 L24,28 L18,22 L12,28 Z M27,9 L9,9 C7.9,9 7,9.9 7,11 L7,23 C7,24.1 7.9,25 9,25 L13,25 L13,23 L9,23 L9,11 L27,11 L27,23 L23,23 L23,25 L27,25 C28.1,25 29,24.1 29,23 L29,11 C29,9.9 28.1,9 27,9 L27,9 Z" fill="#fff" id="ytp-id-33"></path>
			</svg>
		</ng-container>
		<ng-container *ngIf="!connected">

			<svg version="1.1" id="text-OL" x="0px" y="0px"
				viewBox="0 0 125 125" style="enable-background:new 0 0 125 125;" xml:space="preserve">
			
			<g class="st0">
				<rect class="st1" width="125" height="125"/>
			</g>
			<g>
				<defs>
					<path id="SVGID_1_" d="M81,88.8c0.4,0.5,0.4,1.3-0.1,1.7c-0.2,0.2-0.5,0.3-0.8,0.3H44.9c-0.7,0-1.2-0.5-1.2-1.2
						c0-0.3,0.1-0.6,0.3-0.8l17.5-20.1c0.5-0.6,1.3-0.6,1.9-0.1c0,0,0.1,0.1,0.1,0.1L81,88.8z M76.9,77.7l-2.8-3.3h10.5
						c0.9,0.1,1.7-0.1,2.5-0.4c0.5-0.3,1-0.7,1.2-1.2c0.4-0.8,0.5-1.7,0.4-2.5V45.8c0.1-0.9-0.1-1.7-0.4-2.5c-0.3-0.5-0.7-1-1.2-1.2
						c-0.8-0.4-1.7-0.5-2.5-0.4h-44c-0.9-0.1-1.7,0.1-2.5,0.4c-0.5,0.3-1,0.7-1.2,1.2c-0.4,0.8-0.5,1.7-0.4,2.5v24.4
						c-0.1,0.9,0.1,1.7,0.4,2.5c0.3,0.5,0.7,1,1.2,1.2c0.8,0.4,1.7,0.5,2.5,0.4h10.5l-2.8,3.3h-6.7c-3,0-4-0.3-5-0.9
						c-1.1-0.6-1.9-1.4-2.5-2.5c-0.6-1.1-0.9-2.1-0.9-5V46.7c0-3,0.3-4,0.9-5.1c0.6-1.1,1.4-1.9,2.5-2.5c1.1-0.6,2.1-0.9,5-0.9h42.2
						c3,0,4,0.3,5.1,0.9c1.1,0.6,1.9,1.4,2.5,2.5c0.6,1.1,0.9,2.1,0.9,5.1v22.5c0,3-0.3,4-0.9,5c-0.6,1.1-1.4,1.9-2.5,2.5
						c-1.1,0.6-2.1,0.9-5.1,0.9L76.9,77.7z"/>
				</defs>
				<clipPath id="SVGID_2_">
					<use href="#SVGID_1_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st2">
					<g>
						<defs>
							<rect id="SVGID_3_" x="10.1" y="10.5" width="104.9" height="104.9"/>
						</defs>
						<clipPath id="SVGID_4_">
							<use href="#SVGID_3_"  style="overflow:visible;"/>
						</clipPath>
						<g class="st3">
							<rect x="24.8" y="30.1" width="75.4" height="68.8"/>
						</g>
					</g>
				</g>
			</g>
			</svg>
		</ng-container>
	</ng-container>
</a>